var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3751_85094",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 1,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 18,
    height: 18
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3751_85094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 16.75H3.75C3.3375 16.75 2.98425 16.6033 2.69025 16.3097C2.39675 16.0157 2.25 15.6625 2.25 15.25V4.75C2.25 4.3375 2.39675 3.98425 2.69025 3.69025C2.98425 3.39675 3.3375 3.25 3.75 3.25H6.88125C7.01875 2.8125 7.2875 2.453 7.6875 2.1715C8.0875 1.8905 8.525 1.75 9 1.75C9.5 1.75 9.947 1.8905 10.341 2.1715C10.7345 2.453 11 2.8125 11.1375 3.25H14.25C14.6625 3.25 15.0157 3.39675 15.3097 3.69025C15.6032 3.98425 15.75 4.3375 15.75 4.75V8.5H14.25V4.75H12.75V7H5.25V4.75H3.75V15.25H8.25V16.75ZM11.625 15.9437L8.4375 12.7563L9.4875 11.7062L11.625 13.8438L15.8625 9.60625L16.9125 10.6562L11.625 15.9437ZM9 4.75C9.2125 4.75 9.39075 4.678 9.53475 4.534C9.67825 4.3905 9.75 4.2125 9.75 4C9.75 3.7875 9.67825 3.60925 9.53475 3.46525C9.39075 3.32175 9.2125 3.25 9 3.25C8.7875 3.25 8.6095 3.32175 8.466 3.46525C8.322 3.60925 8.25 3.7875 8.25 4C8.25 4.2125 8.322 4.3905 8.466 4.534C8.6095 4.678 8.7875 4.75 9 4.75Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.10782cc6af2fa2837d6fd3693ef1eebf.svg";
export { ForwardRef as ReactComponent };